import Helper from './Helper';

class Header {
  constructor(config = {}) {
    const {
      submenuTogglerSelector,
      menuTogglerSelector,
      menuContainerSelector,
      submenuLinkSelector,
      breakPointLg
    } = config;
    this.breakPointLg = breakPointLg;
    this.body = document.querySelector("body");
    this.submenuToggler = document.querySelectorAll(submenuTogglerSelector);
    this.subTogglerArray = Array.prototype.slice.call(this.submenuToggler);
    this.submenuLinkSelector = Array.prototype.slice.call(document.querySelectorAll(submenuLinkSelector));
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);
    this.submenuOpen = false;
    this.menuOpen = false;
    this.vw = 0;

    this.toggleSubmenu = this.toggleSubmenu.bind(this);

    if (this.submenuToggler) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.vw = window.innerWidth;
    this.menuToggler.addEventListener("click", (e) => {
      this.toggleMenu();
    });

    this.submenuLinkSelector.forEach((link)=>{
      link.addEventListener("click", (e) => {
        this.closeAllSubmenus();
        this.closeMenu();
        this.submenuOpen = false;
        this.menuOpen = false;
      });
    });

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeAllSubmenus();
        this.closeMenu();
        this.submenuOpen = false;
        this.menuOpen = false;
      }
    };

    window.addEventListener('resize', () => {
      this.vw = window.innerWidth;
      this.closeAllSubmenus();
      this.closeMenu();
      this.submenuOpen = false;
      this.menuOpen = false;
    });

    this.subTogglerArray.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          let event = e;
          this.toggleSubmenu(event, toggle, this.vw);
      });
    });
  }

  closeAllSubmenus() {
    this.subTogglerArray.forEach((item) => {
      Helper.removeClass(item.parentNode, "active");
    });
    this.submenuOpen = false;
  }

  closeMenu() {
    Helper.removeClass(this.menuToggler, "burger-active");
    Helper.removeClass(this.body, "menu-open");
    this.menuOpen = false;
  }

  toggleMenu() {
    if (this.menuOpen) {
      this.closeMenu();
    } else {
      Helper.addClass(this.menuToggler, "burger-active");
      Helper.addClass(this.body, "menu-open");
      this.menuOpen = true;
    }
  }

  toggleSubmenu(e, toggle, vw) {
    if(toggle && vw < this.breakPointLg) {
      e.preventDefault();
      const parent = toggle.parentNode;
      if(Helper.hasClass(parent, "active")) {
        this.closeAllSubmenus();
      } else {
        this.subTogglerArray.forEach((item) => {
          Helper.removeClass(item.parentNode, "active");
        });
        Helper.addClass(parent, "active");
        this.submenuOpen = true;
      }
    }
  }
}

export default Header;
